import { NavLink, Routes, Route, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminHeader from "./components/AdminHeader";
import AdminSidebar from "./components/AdminSidebar";
import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import AdminUsers from "./pages/Users/AdminUsers";
import AdminBusinesses from "./pages/Businesses/AdminBusinesses";
import AdminCategories from "./pages/Categories/AdminCategories";
import AdminProfessions from "./pages/Professions/AdminProfessions";
import AdminServices from "./pages/Services/AdminServices";
import "../css/admin.css";

const AdminLayout = () => {
  const { logout, displayName } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="admin-layout">

      {/* Sidebar */}
      <AdminSidebar />

      {/* Main */}
      <main className="admin-main">

        {/* Header */}
        <AdminHeader />

        <section className="admin-content">
          <Routes>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="freelancers" element={<AdminUsers />} />
            <Route path="businesses" element={<AdminBusinesses />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="professions" element={<AdminProfessions />} />
            <Route path="services" element={<AdminServices />} />
          </Routes>
        </section>
      </main>

    </div>
  );
};

export default AdminLayout;